export const getCollectionDataAndTypeById = (state, collectionId) => {
  const curatedCollectionIds = state.cards.curatedCollections.allIds || [];

  if (curatedCollectionIds.includes(collectionId)) {
    return { type: 'curated', collection: state.cards.curatedCollections.byId[collectionId] };
  }

  return { type: 'user', collection: state.collections.userCollections.byId[collectionId] };
};

export const getUserCollections = (state) => {
  const collectionIds = state.user.collectionIds || [];
  return collectionIds.map((id) => state.collections.userCollections.byId[id]);
};

export const isUserCollection = (state, collectionId) => {
  const collectionIds = state.user.collectionIds || [];
  return collectionIds.includes(collectionId);
};

export const getCollectionSummaryById = (state, collectionId) => {
  let collection = state.collections.userCollections?.byId?.[collectionId] || false;

  if (!collection) {
    collection = state.collections.curatedCollections?.byId?.[collectionId] || false;
  }

  if (collection) {
    const thumbnail = collection?.cards?.length ? state.cards.byId[collection.cards[0]] : null;

    return {
      ...collection,
      thumbnail,
    };
  }

  return false;
};

export const getCollectionById = (state, collectionId) => {
  let collection = state.collections.userCollections?.byId?.[collectionId] || false;

  if (!collection) {
    collection = state.cards.curatedCollections?.byId?.[collectionId] || false;
  }

  // loop over cards and get full card data
  if (collection) {
    const fullCards = (collection?.cards || []).map((cardId) => state.cards.byId[cardId]);
    return {
      ...collection,
      cards: fullCards,
    };
  }
  return false;
};

export const getSavedInCollectionsByCardId = (state, cardId) => {
  const byCardId = state.collections.userCollections.byCardId || {};
  const collectionIds = byCardId[cardId] || [];

  return collectionIds.map((id) => state.collections.userCollections.byId[id]);
};

export const cardExistsInCollectionById = (state, collectionId, cardId) => {
  const collection = state.collections.userCollections.byId[collectionId];
  if (!collection) return false;
  return collection?.cards?.includes(cardId) || false;
};
